export default "__VITE_ASSET__CCGNKhs0__"